(function () {
  var EXPERIENCE_MEDIA = {
    date: {
      selector: '#gd-experience-date',
      src: 'https://cdn.shopify.com/s/files/1/0550/6826/2490/files/gd-exp-date-night-v3.jpg?v=1785702973',
      alt: 'Guests sharing an intimate private dining experience inside Gallery DeFi'
    },
    weekend: {
      selector: '#gd-experience-weekend',
      src: 'https://cdn.shopify.com/s/files/1/0550/6826/2490/files/gd-curated-culture-crowd.jpg?v=1785543924',
      alt: 'A lively crowd gathered for an art and culture event inside Gallery DeFi'
    },
    field: {
      selector: '#gd-experience-field',
      src: 'https://cdn.shopify.com/s/files/1/0550/6826/2490/files/field-trip-1.webp?v=1755085915',
      alt: 'Students and educators taking part in a Gallery DeFi field trip'
    }
  };

  var COLLECTOR_MEDIA = [
    {
      src: 'https://cdn.shopify.com/s/files/1/0550/6826/2490/files/PhotoAug282025_112705AM_2.jpg?v=1756424563',
      alt: 'Texas Smoke Em fine art print by Jude'
    },
    {
      src: 'https://cdn.shopify.com/s/files/1/0550/6826/2490/files/Photo_Aug_28_2025_11_27_05_AM_4_3766d0c2-7d6a-44f5-b176-e63810c86f92.jpg?v=1783073964',
      alt: 'Bad Habits fine art print by Jude'
    },
    {
      src: 'https://cdn.shopify.com/s/files/1/0550/6826/2490/files/PhotoAug262025_115959PM_2_22c02b36-0da5-4ead-b7d0-a37a3ff71f5c.jpg?v=1756424056',
      alt: 'Fuzz limited edition print by Minji Kang-Watrous'
    },
    {
      src: 'https://cdn.shopify.com/s/files/1/0550/6826/2490/files/CHRIS-BradyMatthews.jpg?v=1756253861',
      alt: 'Chris Farley fine art print by Brady Matthews'
    }
  ];

  function ensureMediaStyles() {
    if (document.getElementById('gd-experience-media-overrides')) return;

    var style = document.createElement('style');
    style.id = 'gd-experience-media-overrides';
    style.textContent = [
      '.gd-experience-card__media--collector{display:grid!important;grid-template-columns:repeat(4,minmax(0,1fr));}',
      '.gd-experience-card__media--collector figure{height:100%;margin:0;min-width:0;overflow:hidden;}',
      '.gd-experience-card__media--collector figure+figure{border-left:1px solid rgba(255,255,255,.16);}',
      '.gd-experience-card__media--collector img{object-position:center center!important;}',
      '@media(max-width:680px){.gd-experience-card__media--collector{grid-template-columns:repeat(2,minmax(0,1fr));grid-template-rows:repeat(2,minmax(0,1fr));}.gd-experience-card__media--collector figure{height:auto}.gd-experience-card__media--collector figure:nth-child(3){border-left:0;border-top:1px solid rgba(255,255,255,.16)}.gd-experience-card__media--collector figure:nth-child(4){border-top:1px solid rgba(255,255,255,.16)}}'
    ].join('');
    document.head.appendChild(style);
  }

  function setCardImage(root, config) {
    var card = root.querySelector(config.selector);
    var image = card && card.querySelector('.gd-experience-card__media img');
    if (!image) return;

    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.src = config.src;
    image.alt = config.alt;
    image.decoding = 'async';
  }

  function buildCollectorMosaic(root) {
    var card = root.querySelector('#gd-experience-collect');
    var media = card && card.querySelector('.gd-experience-card__media');
    if (!media || media.dataset.gdCollectorReady === 'true') return;

    media.dataset.gdCollectorReady = 'true';
    media.classList.add('gd-experience-card__media--collector');
    media.innerHTML = '';

    COLLECTOR_MEDIA.forEach(function (item) {
      var figure = document.createElement('figure');
      var image = document.createElement('img');
      image.src = item.src;
      image.alt = item.alt;
      image.loading = 'lazy';
      image.decoding = 'async';
      figure.appendChild(image);
      media.appendChild(figure);
    });
  }

  function applyMediaOverrides(root) {
    Object.keys(EXPERIENCE_MEDIA).forEach(function (key) {
      setCardImage(root, EXPERIENCE_MEDIA[key]);
    });
    buildCollectorMosaic(root);
  }

  function initExperiencePage(root) {
    if (!root || root.dataset.gdExperienceReady === 'true') return;

    root.dataset.gdExperienceReady = 'true';
    root.dataset.experienceMode = 'all';
    ensureMediaStyles();
    applyMediaOverrides(root);
    root.classList.add('is-enhanced');

    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var revealItems = Array.prototype.slice.call(
      root.querySelectorAll('[data-gd-reveal], [data-gd-experience-card]')
    );
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-gd-experience-card]'));
    var filters = Array.prototype.slice.call(root.querySelectorAll('[data-gd-experience-filter]'));
    var stage = root.querySelector('[data-gd-experience-stage]');

    filters.forEach(function (button) {
      button.addEventListener('click', function () {
        var mode = button.getAttribute('data-gd-experience-filter') || 'all';
        root.dataset.experienceMode = mode;

        filters.forEach(function (item) {
          item.setAttribute('aria-pressed', String(item === button));
        });

        cards.forEach(function (card) {
          var matches = mode === 'all' || card.getAttribute('data-gd-category') === mode;
          card.classList.toggle('is-selected', mode !== 'all' && matches);
          card.classList.toggle('is-dimmed', mode !== 'all' && !matches);
        });
      });
    });

    if (!prefersReducedMotion && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
      );

      revealItems.forEach(function (item) {
        observer.observe(item);
      });
    } else {
      revealItems.forEach(function (item) {
        item.classList.add('is-visible');
      });
    }

    if (finePointer && !prefersReducedMotion) {
      cards.forEach(function (card) {
        card.addEventListener('pointermove', function (event) {
          var rect = card.getBoundingClientRect();
          var x = (event.clientX - rect.left) / rect.width;
          var y = (event.clientY - rect.top) / rect.height;
          var rotateY = (x - 0.5) * 3.2;
          var rotateX = (0.5 - y) * 3.2;

          card.style.setProperty('--gd-card-rx', rotateX.toFixed(2) + 'deg');
          card.style.setProperty('--gd-card-ry', rotateY.toFixed(2) + 'deg');
        });

        card.addEventListener('pointerleave', function () {
          card.style.setProperty('--gd-card-rx', '0deg');
          card.style.setProperty('--gd-card-ry', '0deg');
        });
      });

      if (stage) {
        stage.addEventListener('pointermove', function (event) {
          var rect = stage.getBoundingClientRect();
          var x = (event.clientX - rect.left) / rect.width - 0.5;
          var y = (event.clientY - rect.top) / rect.height - 0.5;
          stage.style.setProperty('--gd-stage-x', (x * 8).toFixed(2) + 'px');
          stage.style.setProperty('--gd-stage-y', (y * 8).toFixed(2) + 'px');
        });

        stage.addEventListener('pointerleave', function () {
          stage.style.setProperty('--gd-stage-x', '0px');
          stage.style.setProperty('--gd-stage-y', '0px');
        });
      }
    }
  }

  function boot() {
    var roots = document.querySelectorAll('[data-gd-experiences]');
    Array.prototype.forEach.call(roots, initExperiencePage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
